import { render, staticRenderFns } from "./ImageAnnotation.vue?vue&type=template&id=7ab9b042&scoped=true"
import script from "./ImageAnnotation.vue?vue&type=script&lang=js"
export * from "./ImageAnnotation.vue?vue&type=script&lang=js"
import style0 from "./ImageAnnotation.vue?vue&type=style&index=0&id=7ab9b042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab9b042",
  null
  
)

export default component.exports